var map = {
	"./about.png": "35dc",
	"./ads.png": "181d",
	"./alarm.png": "964e",
	"./app_in_app.png": "0b00",
	"./attraction.png": "9a81",
	"./back_arrow.png": "818c",
	"./bell.png": "1a0e",
	"./cctv.png": "acdb",
	"./channel.png": "37c6d",
	"./channel_category.png": "18a2",
	"./company.png": "f0cf",
	"./dashboard.png": "0316",
	"./extra_menu.png": "cfdf",
	"./facility.png": "409b",
	"./food_category.png": "1179",
	"./greeting.png": "83fd",
	"./guest.png": "dc91",
	"./html.png": "a833",
	"./image.png": "c048",
	"./info_berhasil.png": "10f2",
	"./info_warning.png": "b73e",
	"./linear_channel.png": "6f60",
	"./master.png": "8a61",
	"./menu.png": "7121",
	"./nursing.png": "f494",
	"./order.png": "87aa",
	"./plus_ads.png": "1bc5",
	"./prayer.png": "cac6",
	"./promo.png": "7150",
	"./room.png": "635a",
	"./screensaver.png": "8a00",
	"./service.png": "bfae",
	"./setting.png": "b43e",
	"./siren.png": "f8ac",
	"./text.png": "b5db",
	"./user.png": "fc48",
	"./video.png": "bf55",
	"./wallpaper.png": "4ed8",
	"./webview.png": "a42b",
	"./youtube.png": "6f7f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8cba";